import { unstable_createMuiStrictModeTheme as createMuiTheme } from '@material-ui/core';

import { createThemeOptions, palette } from './theme';

const vgrdPalette = {
  ...palette,
  primary: {
    // --color-accent-muted from vgrd-gruppe.de
    light: '#00B0F0',
    main: '#004B93',
    dark: '#003366',
    // `primary` is replaced wholesale rather than merged, so accent has to be restated. Blue-tinted
    // counterpart of the default theme's warm off-white (see NewDealerRow).
    accent: '#f5f9fd',
  },
  // .image-gallery-icon { color: #fff } from vgrd-gruppe.de - the dark blue primary color
  // barely shows up on top of car photos, so gallery arrows/fullscreen icon/bullets stay light
  galleryIcon: {
    light: 'rgba(255, 255, 255, 0.6)',
    main: '#00B0F0',
    dark: '#004B93',
  },
  // the dark blue primary reads as almost black on the icon's light chip background, so the active
  // watchlist binoculars use the lighter accent blue instead (CarImage, WatchlistIcon)
  watchlistIconActive: '#00B0F0',
};

const vgrdSliderTrackColor = '#abe2fb';

const vgrdThemeOptions = createThemeOptions(vgrdPalette);

export const vgrdTheme = createMuiTheme({
  palette: vgrdPalette,
  ...vgrdThemeOptions,
  overrides: {
    ...vgrdThemeOptions.overrides,
    MuiSlider: {
      rail: { backgroundColor: '#e9e9e9' },
      track: { backgroundColor: vgrdSliderTrackColor },
      thumb: {
        backgroundColor: '#ffffff',
        border: `2px solid ${vgrdSliderTrackColor}`,
      },
    },
    // --button-rounded / --button-spacing from vgrd-gruppe.de
    MuiButton: {
      root: {
        borderRadius: 20,
      },
      contained: {
        padding: '8px 32px',
      },
    },
  },
});
